import { useEffect, useState } from 'react';
import style from './index.module.scss'
import StarEmpty from "@/assets/icons/black-empty-star.svg";
import EmptyStar from "@/assets/icons/black-star.svg";
interface PropsType {
  onClickStar?: (num: number) => void
  scoreNum?: number
}
const Rate = ({ onClickStar, scoreNum = 0 }: PropsType) => {
  const [star, setStar] = useState(0)

  const handleClickStar = (num: number) => {
    setStar(num)
    onClickStar && onClickStar(num)
  }

  useEffect(() => {
    setStar(scoreNum)
  }, [scoreNum])

  return (
    <div className={style.stars}>
      {
        [1, 2, 3, 4, 5].map((item, index) => {
          return (
            <div
              className={style.star}
              onClick={() => handleClickStar(item)}
              key={item}
            >
              {
                star >= item ? <EmptyStar width={14} height={14}></EmptyStar> :
                  <StarEmpty width={14} height={14}></StarEmpty>
              }
            </div>
          )
        })
      }
    </div>
  )

}

export default Rate